module.exports = __webpack_public_path__ + "static/media/ssr.bdaeaa9c.svg";